'use client';
import './GermanyGuide.css';
import Image from 'next/image';

const GermanyGuide = () => {
  return (
    <section className="munich-guide">
      <div className="hero-banner">
        <div className="banner-content">
          <h1 className="mb-2">Helping Indians Connect & Settle in Munich</h1>
          <p className="subtitle">
            Connecting Indians in Munich with essential resources, community events, and local insights<br />
            to make your experience in Bavaria's capital truly exceptional.
          </p>
        </div>
      </div>

      <div className="features-container">
        <div className="feature-item">
          <Image src="/images/GermanyGuide/Business.png" className="featureIcon" alt="Business" width={24} height={24} />
          Business Listings
        </div>
        <div className="feature-item">
          <Image src="/images/GermanyGuide/cultural.png" className="featureIcon" alt="Cultural" width={ 24} height={ 24} />
          Cultural Insights
        </div>
        <div className="feature-item">
          <Image src="/images/GermanyGuide/helpful.png" className="featureIcon" alt="Helpful" width={ 24} height={ 24} />
          Helpful Resources
        </div>
        <div className="feature-item">
          <Image src="/images/GermanyGuide/community.png" className="featureIcon" alt="Community" width={ 24} height={ 24} />
          Community Forum
        </div>
      </div>
    </section>
  );
};

export default GermanyGuide;
